import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Select from "react-select"
import { getBranches, selectedBranch } from "store/actions"
import { useDispatch, useSelector } from "react-redux"
import useRole from "hooks/useRole"

const BranchFilter = props => {
  const dispatch = useDispatch()
  const { isSuperAdmin } = useRole()

  const {
    loading,
    branches,
    selectedBranch: selectedBranchDetails,
  } = useSelector(state => ({
    loading: state.Branches.loading,
    branches: state.Branches.branches,
    selectedBranch: state.Branches.selectedBranch,
  }))

  const [branch, setBranch] = useState({ label: "All", value: "" })
  const [branchSearch, setBranchSearch] = useState("")

  useEffect(() => {
    if (isSuperAdmin()) {
      dispatch(getBranches(1, 10, branchSearch, "", ""))
    }
  }, [dispatch, branchSearch])

  const branchOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: branches?.branches
        ?.filter(branch => branch?.branch_name !== "All")
        .map((result, index) => ({
          key: index,
          label: result?.branch_name,
          value: result._id,
        })),
    },
  ]

  const handleEnteredBranch = textEntered => {
    setBranchSearch(textEntered)
  }

  function handleFinalValuesBranch(event) {
    const updatedEvent = event.label === "All" ? { ...event, value: "" } : event

    setBranch(updatedEvent)
    sessionStorage.setItem("branchId", updatedEvent.value)
    sessionStorage.setItem("branch", updatedEvent.label)

    dispatch(selectedBranch(updatedEvent))
  }

  useEffect(() => {
    const branchLabel = sessionStorage.getItem("branch")
    const branchId = sessionStorage.getItem("branchId")

    if (selectedBranchDetails?.label) {
      const branchData =
        selectedBranchDetails.label === "All"
          ? { ...selectedBranchDetails, value: "" }
          : selectedBranchDetails
      setBranch(branchData)
    } else if (branchLabel) {
      const branchData = {
        label: branchLabel,
        value: branchLabel === "All" ? "" : branchId || "",
      }
      setBranch(branchData)
      // Dispatch to Redux so other components can access the selected branch after page refresh
      dispatch(selectedBranch(branchData))
    }
  }, [selectedBranchDetails, dispatch])

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "4px 10px",
    background: "#f8f9fa",
    borderRadius: "6px",
    border: "1px solid #e2e6ea",
  }

  const labelStyle = {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#556ee6",
    whiteSpace: "nowrap",
  }

  const iconStyle = {
    fontSize: "13px",
    color: "#556ee6",
  }

  const selectContainerStyle = {
    width: "150px",
  }

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "4px",
      border: state.isFocused ? "1px solid #556ee6" : "1px solid #ced4da",
      boxShadow: "none",
      minHeight: "28px",
      backgroundColor: "#fff",
      "&:hover": {
        borderColor: "#556ee6",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 6px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#556ee6"
        : state.isFocused
          ? "rgba(85, 110, 230, 0.1)"
          : "#fff",
      color: state.isSelected ? "#fff" : "#495057",
      padding: "6px 10px",
      fontSize: "12px",
      cursor: "pointer",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#495057",
      fontWeight: "500",
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#adb5bd",
      fontSize: "12px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "6px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
      border: "1px solid #e9ecef",
      overflow: "hidden",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#556ee6",
      padding: "2px 4px",
      "&:hover": {
        color: "#556ee6",
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "26px",
    }),
  }

  console.log(branch);
  console.log(branches);



  return (
    <div style={containerStyle}>
      <div style={labelStyle}>
        <i className="bx bx-buildings" style={iconStyle}></i>
        <span>Branch</span>
      </div>
      <div style={selectContainerStyle}>
        <Select
          onInputChange={handleEnteredBranch}
          value={branch}
          placeholder="Select"
          onChange={handleFinalValuesBranch}
          options={branchOptions}
          styles={customSelectStyles}
          isLoading={loading}
        />
      </div>
    </div>
  )
}

BranchFilter.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default BranchFilter
